import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    const handleAuthCallback = async () => {
      const { data: { session }, error } = await supabase.auth.getSession()
      
      if (error) {
        console.error('Error getting session:', error)
        navigate('/login')
        return
      }

      if (session) {
        navigate('/app')
      } else {
        navigate('/sign-in')
      }
    }

    handleAuthCallback()
  }, [navigate])

  return (
    <div className="min-h-screen bg-background-light flex items-center justify-center">
      <div className="text-charcoal-muted">Loading...</div>
    </div>
  )
}
